import React from "react";

import { moneyFormat } from "./format";
import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { pickMillions, getTeam } from "./utils";
import Auth from "routes/Auth";

const Valuation3 = ({
  teams,
  competitiveAnalysis,
  competitionMetrics,
  teamId
}) => {
  const data = competitiveAnalysis || competitionMetrics;
  const field = "Market Capitalization";
  return (
    <OnePanelChart
      title="Valuation"
      prefix="$"
      suffix="M"
      data={pickMillions(teams, data, field)}
      teams={teams}
    >
      <Text>
        In this round, equity investors used the Discounted Cash Flow (DCF)
        valuation method to value your business at{" "}
        {moneyFormat(getTeam(teamId, data)[field])}.
      </Text>
      <Text>
        The DCF model, in this game, predicts your future cash flows, based on
        past performance and other factors, and discount those cash flows using
        an appropriate discount rate to determine the present value (i.e. your
        business value).
      </Text>
      <Text>The discount rate used in this game is your Cost of Capital.</Text>
    </OnePanelChart>
  );
};

export default Valuation3;



// WEBPACK FOOTER //
// ./src/components/analysis/Valuation3.js